import React from "react";
import PropTypes from "prop-types";
import { Col, Modal, ModalBody, Row, ModalFooter } from "reactstrap";
import "flatpickr/dist/themes/material_blue.css";
import { AvForm } from "availity-reactstrap-validation";
import { connect } from "react-redux";
import ApplicationForm from "../../../../../../components/forms/ApplicationForm";
import SweetAlert from "react-bootstrap-sweetalert";
import styled from "styled-components";

const dashboardTypes = [
  {
    value: 1,
    label: "SKAD",
  },
  {
    value: 2,
    label: "OVERVIEW",
  },
  {
    value: 3,
    label: "SKAD_WITH_OVERVIEW",
  },
];

const attributionTypes = [
  {
    value: null,
    label: "NONE",
  },
  {
    value: "FIRST",
    label: "FIRST",
  },
  {
    value: "DYNAMIC",
    label: "DYNAMIC",
  },
];

const AddAppModal = props => {
  const {
    isOpen,
    toggle,
    app_data,
    tracking_platforms,
    client_id,
    editData,
    addAppById,
    app,
    patchApp,
    patchAppStatus,
    setApp,
  } = props;

  const [selectedTracker, setSelectedTracker] = React.useState();
  const [selectDashboard, setSelectDashboard] = React.useState();
  const [selectAttrType, setSelectAttrType] = React.useState();
  const [infoAlert, setInfoAlert] = React.useState(false);
  const [infoData, setInfoData] = React.useState(null);
  const [editApp, setEditApp] = React.useState();

  React.useEffect(() => {
    if (editData !== null) {
      setEditApp(editData);
      let dIdx = dashboardTypes.findIndex(
        i => i.value == editData.dashboard_type
      );

      let attrIdx = attributionTypes.findIndex(i => i.value == editData.attribution_type);

      setSelectDashboard({
        ...dashboardTypes[dIdx],
      });

      if (attrIdx >= 0) {
        setSelectAttrType({
          ...attributionTypes[attrIdx],
        });
      } else {
        setSelectAttrType({
          ...attributionTypes[0],
        });
      }



      let tracking_p = props.editData.tracking_platform;
      switch (tracking_p) {
        case "1": {
          setSelectedTracker({
            label: "APPSFLYER",
            value: "APPSFLYER",
          });
          break;
        }
        case "APPSFLYER": {
          setSelectedTracker({
            label: "APPSFLYER",
            value: "APPSFLYER",
          });
          break;
        }
        case "2": {
          setSelectedTracker({
            label: "ADJUST",
            value: "ADJUST",
          });
          break;
        }
        case "ADJUST": {
          setSelectedTracker({
            label: "ADJUST",
            value: "ADJUST",
          });
          break;
        }
        case "3": {
          setSelectedTracker({
            label: "REPORT",
            value: "REPORT",
          });
          break;
        }
        case "REPORT": {
          setSelectedTracker({
            label: "REPORT",
            value: "REPORT",
          });
          break;
        }
        default: {
          setSelectedTracker({
            label: "NONE",
            value: "NONE",
          });
        }
      }
    } else {
      setSelectDashboard({
        ...dashboardTypes[0],
      });
      setSelectAttrType({
        ...attributionTypes[0],
      });
      setSelectedTracker({
        label: "NONE",
        value: "NONE",
      });
    }

    return () => {
      setEditApp(null);
      setApp(null);
      props.setAppDataNull();
    };
  }, []);

  React.useEffect(() => {
    if (app !== null) {
      setEditApp(app);
    }
  }, [app]);

  const handleValidOrderSubmit = (e, errors, params) => {
    if (editApp == null && errors?.length === 0) {
      let data = {
        name: params.app_name,
        client_id: client_id,
        link: params.app_link,
        app_picture: params?.app_picture,
        dashboard_type: selectDashboard.value,
        type: 1,
        tracking_platform:
          selectedTracker?.label == "NONE" ? null : selectedTracker.label,
        attribution_type: selectAttrType.value || null,
        ...(params?.account_id && { account_id: params.account_id })
      };

      if (selectedTracker?.label == "ADJUST") {
        data["general_token"] = params?.general_token;
      } else {
        data["general_token"] = null;
      }

      addAppById(client_id, data);
      console.log('2')
      toggle();
    } else if (editApp && errors?.length === 0) {
      console.log('3')
      let data = {
        name: params.app_name,
        client_id: client_id,
        link: params.app_link,
        app_picture: params?.app_picture,
        dashboard_type: selectDashboard.value,
        type: 1,
        tracking_platform:
          selectedTracker?.label == "NONE" ? null : selectedTracker.label,
        attribution_type: selectAttrType.value || null,
        ...(params?.account_id && { account_id: params.account_id })
      };

      if (selectedTracker?.label == "ADJUST") {
        data["general_token"] = params?.general_token;
      } else {
        data["general_token"] = null;
      }

      if (editApp?.is_active) {
        props.patchApp(client_id, editApp?.id, data);
        toggle();
      } else {
        toggle();
      }
    }
  };

  const onClickStatus = (appName, currentStatus) => {
    const data = {
      appName,
      title: "Change application status",
      curStatus: currentStatus ? "yes" : "no",
      onConfirm: () => {
        props.patchAppStatus(editApp.id, client_id, {
          is_active: !currentStatus,
        });
        setInfoAlert(false);
      },
    };
    setInfoData(data);
    setInfoAlert(!infoAlert);
  };

  const onClickRent = (appName, currentStatus) => {
    const data = {
      appName,
      title: "Change rent status",
      rentStatus: currentStatus ? "yes" : "no",
      onConfirm: () => {
        props.patchAppStatus(editApp.id, client_id, {
          is_rent: !currentStatus,
        });
        setInfoAlert(false);
      },
    };
    setInfoData(data);
    setInfoAlert(!infoAlert);
  };

  const can_editable =
    (editApp && props.permissions["change_clientapplicationmodel"]) ||
    (editApp && props.permissions["add_clientapplicationmodel"]);

  return (
    <Modal
      size="lg"
      isOpen={isOpen}
      autoFocus={true}
      centered={true}
      toggle={toggle}
    >
      {props.permissions["change_clientapplicationmodel"] && infoAlert && (
        <SweetAlert
          showCancel
          confirmBtnText="Change"
          cancelBtnText="Cancel"
          confirmBtnBsStyle="success"
          title={infoData?.title || "Default name"}
          onCancel={() => setInfoAlert(false)}
          onConfirm={infoData.onConfirm}
        >
          {infoData?.curStatus ? (
            infoData.curStatus == "yes" ? (
              <p>Are you sure want to change application status to inactive?</p>
            ) : (
              <p>Are you sure want to change application status to active?</p>
            )
          ) : (
            ""
          )}

          {infoData?.rentStatus ? (
            infoData.rentStatus == "yes" ? (
              <p>Are you sure want to change application rent status?</p>
            ) : (
              <p>Are you sure want to change application rent status?</p>
            )
          ) : (
            ""
          )}
        </SweetAlert>
      )}

      <div className="modal-header">
        <h4 className="modal-title mt-0" id="myModalLabel">
          {editApp ? "Edit" : "Add"} application
        </h4>
        <button
          type="button"
          onClick={toggle}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <AvForm className="needs-validation" onSubmit={handleValidOrderSubmit}>
        <ModalBody>
          <ApplicationForm
            changeStatusApp={onClickStatus}
            type={editApp ? "edit" : ""}
            dashboardTypes={dashboardTypes}
            attributionTypes={attributionTypes}
            setSelectAttrType={setSelectAttrType}
            selectAttrType={selectAttrType}
            setSelectDashboard={setSelectDashboard}
            selectDashboard={selectDashboard}
            app={editApp}
            app_data={app_data}
            tracking_platforms={
              tracking_platforms?.tracking_platform.length > 0
                ? tracking_platforms?.tracking_platform.map((i, k) => {
                  return {
                    label: i.toUpperCase(),
                    value: i.toUpperCase(),
                  };
                })
                : []
            }
            selectedTracker={selectedTracker}
            setSelectedTracker={setSelectedTracker}
          />
        </ModalBody>
        <StyledFooter>
          <Row className="justify-content-end">
            {/* <Col className={editApp != null ? "edit" : "d-none"}>
              <button
                type="button"
                onClick={() =>
                  can_editable &&
                  onClickStatus(
                    app_data?.title || editApp?.name,
                    editApp?.is_active
                  )
                }
                disabled={!can_editable}
                className={`btn ${
                  editApp?.is_active ? "btn-success" : "btn-warning"
                } waves-effect btn-label waves-light`}
              >
                <i
                  className={`bx ${
                    editApp?.is_active ? "bx-check" : "bx-block"
                  } label-icon`}
                />
                App is {editApp?.is_active ? "active" : "inactive"}
              </button>
            </Col> */}
            <Col sm={6} className={editApp ? "" : "d-none"}>
              <div className="text-start">
                <button
                  type="button"
                  onClick={() =>
                    can_editable &&
                    onClickStatus(
                      app_data?.title || editApp?.name,
                      editApp?.is_active
                    )
                  }
                  disabled={!can_editable}
                  className={`btn ${editApp?.is_active ? "btn-success" : "btn-warning"
                    } waves-effect btn-label waves-light`}
                >
                  <i
                    className={`bx ${editApp?.is_active ? "bx-check" : "bx-block"
                      } label-icon`}
                  />
                  App is {editApp?.is_active ? "active" : "inactive"}
                </button>
                <button
                  type="button"
                  onClick={() =>
                    can_editable &&
                    onClickRent(
                      app_data?.title || editApp?.name,
                      editApp?.is_rent
                    )
                  }
                  disabled={!can_editable}
                  className={`btn ${editApp?.is_rent ? "btn-info" : "btn-secondary"
                    } waves-effect btn-label waves-light ms-2`}
                >
                  <i
                    className={`bx ${editApp?.is_rent ? "bx-check" : "bx-block"
                      } label-icon`}
                  />
                  {editApp?.is_rent ? "Rent" : "Not rent"}
                </button>
              </div>
            </Col>
            <Col sm={6} className="d-flex justify-content-end">
              <div className="text-end">
                <button
                  onClick={e => {
                    e.preventDefault();
                    toggle();
                  }}
                  className="btn btn-primary save-user"
                >
                  Close
                </button>
                {props.permissions?.["change_clientapplicationmodel"] && (
                  <button
                    type="submit"
                    className="btn btn-success save-user ms-2"
                  >
                    Save changes
                  </button>
                )}
              </div>
            </Col>
          </Row>
        </StyledFooter>
      </AvForm>
    </Modal>
  );
};

const StyledFooter = styled.div`
  padding: 16px;
  border-top: 1px solid #eff2f7;
`;

AddAppModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  data: PropTypes.any,
  editData: PropTypes.any,
  permissions: PropTypes.any,
  getTrackerPlatforms: PropTypes.func,
  setAppDataNull: PropTypes.func,
  addAppById: PropTypes.func,
  app_data: PropTypes.any,
  tracking_platforms: PropTypes.any,
  client_id: PropTypes.node,
  app: PropTypes.any,
  patchAppStatus: PropTypes.func,
  patchApp: PropTypes.func,
  setApp: PropTypes.func,
};

const mapStateToProps = state => ({
  app: state.Apps.app,
  app_data: state.Apps.app_data,
});

export default connect(mapStateToProps, null)(AddAppModal);
